module.exports = __webpack_public_path__ + "static/media/checked-white.b43b125a.svg";